import { render } from "./TableUsers.vue?vue&type=template&id=d1c6c0d0&scoped=true"
import script from "./TableUsers.vue?vue&type=script&lang=js"
export * from "./TableUsers.vue?vue&type=script&lang=js"

import "./TableUsers.vue?vue&type=style&index=0&id=d1c6c0d0&lang=sass&scoped=true"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1c6c0d0"]])

export default __exports__